import { render } from "./MyAccountComponent.vue?vue&type=template&id=6f7db522"
import script from "./MyAccountComponent.vue?vue&type=script&lang=js"
export * from "./MyAccountComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__